// src/components/Testimonials.js
import React from 'react';

const testimonials = [
  {
    name: 'Bala Ramanan',
    role: 'Managing Director, Everhomes Constructions',
    text: 'I recently had the opportunity to collaborate with HFA Digital Creations for the development of my website, and I am thoroughly impressed with the quality of their service. From the initial consultation to the final launch, their team demonstrated professionalism, clear communication, and meticulous attention to detail.',
    rating: 5,
  },
  {
    name: 'Priya K.',
    role: 'Owner, Local Service Business',
    text: 'From logo to website to social media creatives, the team handled everything and helped us look professional online.',
    rating: 5,
  },
  {
    name: 'Arun M.',
    role: 'Startup Co-founder',
    text: 'The strategy call was practical and clear. We finally understood what to fix on our landing pages and campaigns.',
    rating: 4.8,
  },
];

const Testimonials = () => {
  return (
    <section className="section" aria-labelledby="testimonials-heading">
      <div className="section-inner">
        <div className="section-header">
          <h2 id="testimonials-heading">Brands growing with HFA Digital Creations</h2>
          <p>
            Business owners across industries trust HFA Digital Creations for reliable, creative,
            and measurable digital growth.
          </p>
        </div>
        <div className="grid-3 testimonials-grid grid" itemScope itemType="https://schema.org/ItemList">
          {testimonials.map((t, index) => (
            <article
              key={t.name}
              className="testimonial-card glass-card reveal-on-scroll"
              itemScope
              itemProp="itemListElement"
              itemType="https://schema.org/Review"
            >
              <div className="stars" aria-label={`${t.rating} star rating`}>
                <span className="stars-animated">★★★★★</span>
              </div>
              <p className="testimonial-text" itemProp="reviewBody">
                “{t.text}”
              </p>
              <p className="testimonial-author">
                <span itemProp="author">{t.name}</span> • <span>{t.role}</span>
              </p>
              <meta itemProp="reviewRating" content={String(t.rating)} />
            </article>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Testimonials;
